module.exports = __webpack_public_path__ + "media/images/a3/lottie/graph2.json";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/a3/lottie/graph2.json
// module id = 8
// module chunks = 0